module.exports = __webpack_public_path__ + "static/media/articlePlaceholder.e52ccbb8.png";